import { render, staticRenderFns } from "./addAntManage.vue?vue&type=template&id=bf756132&scoped=true"
import script from "./addAntManage.vue?vue&type=script&lang=ts"
export * from "./addAntManage.vue?vue&type=script&lang=ts"
import style0 from "./addAntManage.vue?vue&type=style&index=0&id=bf756132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf756132",
  null
  
)

export default component.exports